import $ from 'jquery';

$(document).ready(function () {
  acfFAQBlock();
});

function acfFAQBlock() {
  $('.js-acf-faq-block').each(function () {});
}
